import React from 'react';
import { TpPromptTaskContext, TpTaskFormData, TpTaskFormElemDef, TpTaskFormParsedElemData } from './interfaces';
import { ElemValueWrapper } from '../helpers/ElemValueWrapper';
import { TASKFORM_DEFINITION_TYPES } from '../../../api/models/tasks';

function setInitialData(elemDef: any, ctx: TpPromptTaskContext, formData: TpTaskFormData) {
  formData.elemValues[elemDef.id] = elemDef.defaultValue;
}

function generate(
  elemDef: any,
  ctx: TpPromptTaskContext,
  formData: TpTaskFormData,
  updateElemValue: (elemId: string, newValue: any) => void,
) {
  let relations = ctx.assetInfo.relations;
  if (elemDef.relationType) relations = relations.filter((rel) => rel.type == elemDef.relationType);
  const relatedAssetIds = relations.map((rel) => rel.to);

  if (JSON.stringify(relatedAssetIds) != JSON.stringify(formData.elemValues[elemDef.id]))
    updateElemValue(elemDef.id, relatedAssetIds);

  return (
    <ElemValueWrapper elemName={elemDef.displayName}>
      <div>{relations.length} asset(s)</div>
    </ElemValueWrapper>
  );
}

function parseElemValue(ctx: TpPromptTaskContext, elemDef: any, input: any): TpTaskFormParsedElemData {
  return {
    value: input,
    errorString: null,
  };
}

function addSpecificSchema(schema: any): any {
  schema.properties.relationType = {
    type: TASKFORM_DEFINITION_TYPES.STRING,
    description: 'Identifier of the relation as defined in the ontology',
  };
  schema.required.push('choices');
}

const taskFormElemAssetListDef: TpTaskFormElemDef = {
  type: TASKFORM_DEFINITION_TYPES.ASSET_LIST,
  name: 'Asset List',
  description: 'Prompts the user for a selection of assets.',
  hasData: true,
  addSpecificSchema,
  setInitialData,
  generate,
  parseElemValue,
};

export default taskFormElemAssetListDef;
